import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE } from './apiEndpoints';

export const YANDEX_OAUTH_START_PATH = '/api/login/oauth/yandex';
export const VK_OAUTH_START_PATH = '/api/login/oauth/vk';

const OAUTH_ERROR_KEYS = {
  not_configured: 'login.oauthNotConfigured',
  denied: 'login.oauthDenied',
  failed: 'login.oauthFailed',
  no_email: 'login.oauthNoEmail',
  invalid_state: 'login.oauthInvalidState',
  terms_required: 'login.oauthTermsRequired',
};

export function yandexOAuthErrorKey(code: string | null | undefined) {
  if (!code || typeof code !== 'string') return null;
  return OAUTH_ERROR_KEYS[code] || 'login.oauthFailed';
}

/** Считывает oauth_error из URL и оставляет код в стейте, чтобы перевод успел загрузиться. */
export function useYandexOAuthErrorKey() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    const oauthError = searchParams.get('oauth_error');
    if (!oauthError) return;
    setCode(oauthError);
    const next = new URLSearchParams(searchParams);
    next.delete('oauth_error');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return yandexOAuthErrorKey(code);
}

/**
 * Уводит браузер на серверный старт OAuth Яндекса.
 * @param {{ next?: string, origin?: 'login' | 'register', agreed?: boolean }} [opts]
 */
export function startYandexOAuth(opts: { next?: string; origin?: 'login' | 'register'; agreed?: boolean } = {}) {
  startSocialOAuth(YANDEX_OAUTH_START_PATH, opts);
}

export function startVkOAuth(opts: { next?: string; origin?: 'login' | 'register'; agreed?: boolean } = {}) {
  startSocialOAuth(VK_OAUTH_START_PATH, opts);
}

function startSocialOAuth(
  path: string,
  opts: { next?: string; origin?: 'login' | 'register'; agreed?: boolean } = {}
) {
  const params = new URLSearchParams();
  if (typeof opts.next === 'string' && opts.next.startsWith('/') && !opts.next.startsWith('//')) {
    params.set('next', opts.next);
  }
  if (opts.origin === 'register') {
    params.set('origin', 'register');
  }
  if (opts.agreed) {
    params.set('agreed', '1');
  }
  const query = params.toString();
  window.location.assign(`${API_BASE}${path}${query ? `?${query}` : ''}`);
}
